export const urlAuditV2 = '/admin/audit';
export const urlChannels = '/admin/channel';
export const urlChannelWppSetup = '/admin/channel/whatsapp-setup';
export const urlChannelWppTemplate = '/admin/channel/whatsapp-template-editor';
export const urlChannelFbAccount = '/admin/channel/fbaccount';
export const urlChannelInstagramAccount = '/admin/channel/instagram';
export const urlChannelTelegramAccount = '/admin/channel/tgaccount';
export const urlChannelLivechatAccount = '/admin/channel/livechataccount';
export const urlChannelWppCatalogueSetup = '/admin/channel/ws-catalogue-setup';
export const urlDepartments = '/admin/departments';
export const urlFlowBuilder = '/admin/flow-builder';
export const urlMyReports = '/admin/myreports';
export const urlAnalyticsChatsGeneral = '/admin/analytics/chats-general';
export const urlAnalyticsAgentNotifications =
  '/admin/analytics/agent-notifications';
export const urlAnalyticsChatTimes = '/admin/analytics/chat-times';
export const urlAnalyticsContactTags = '/admin/analytics/contact-tags';
export const urlAnalyticsAgentChats = '/admin/analytics/agent-chats';
export const urlAnalyticsChannelChats = '/admin/analytics/channel-chats';
export const urlAnalyticsCallConsumptionReport =
  '/admin/analytics/call-consumption-report';
export const urlAnalyticsDailyMessages = '/admin/analytics/daily-messages';
export const urlAnalyticsChatTransfers = '/admin/analytics/chat-transfers';
export const urlAnalyticsLoginLogout = '/admin/analytics/login-logout';
export const urlAnalyticsAuditExports = '/admin/analytics/audit-exports';
export const urlAnalyticsChatTags = '/admin/analytics/chat-tags';
export const urlAnalyticsChatsByDepartment =
  '/admin/analytics/chats-by-department';
export const urlAnalyticsWAConversations =
  '/admin/analytics/whatsapp-conversations';
export const urlAnalyticsServiceMessages = '/admin/analytics/service-messages';
export const urlAnalyticsAIConversations = '/admin/analytics/ai-conversations';
export const urlAnalyticsWhBiz = '/admin/analytics/wh-biz';
export const urlAnalyticsSendMessagesWhatsapp = '/admin/analytics/send-msgs-wa';
export const urlAnalyticsWhatsappTraffic = '/admin/analytics/whatsapp-traffic';
export const urlAnalyticsWhatsappTemplates =
  '/admin/analytics/whatsapp-templates';
export const urlFaqsSetup = '/admin/faqs/setup';
export const urlFaqsQA = '/admin/faqs/questionsanswers';
export const urlAnalyticsFaqs = '/admin/analytics/faqs';
export const urlSatisfactionConfiguration = '/admin/satisfaction/configuration';
export const urlAnalyticsCustomerSatisfactionBinary =
  '/admin/analytics/customer-satisfaction-binary';
export const urlAnalyticsCustomerSatisfactionStars =
  '/admin/analytics/customer-satisfaction-stars';
export const urlAnalyticsUniqueContacts =
  '/admin/analytics/incoming-unique-contacts';
export const urlMessagesSetup = '/admin/messagesSetup';
export const urlMyAccount = '/admin/myaccount';
export const urlCustomFields = '/admin/customfields';
export const pathQuickMessages = '/admin/quickMessages';
export const pathBusinessTime = '/admin/businessTime';
export const pathAutomaticMessages = '/admin/automatic-messages';
export const pathIntegrations = '/admin/integrations';
export const pathIntegrationInstall = '/admin/integrations/install';
export const pathChatsBehavior = '/admin/chats-behavior';
export const pathGeneralsConfig = '/admin/generals';
export const pathGeneralSettings = '/admin/general-settings';
export const pathManageSubscription = '/admin/subscription';
export const urlContact = '/admin/contact';
export const urlUser = '/admin/user';
export const urlChatsManagement = '/admin/chats-management';
export const urlBatchMessages = '/admin/deliveries-massive';
export const urlBatchMessagesGeneralReport =
  '/admin/deliveries-massive/general-report';
export const urlTagsConverManagement = '/admin/tags-conver-management';
export const urlTagsContactManagement = '/admin/tags-contacts-management';
export const urlAgentConsole = '/agent/chat';
export const urlOrdersOrder = '/admin/order';
export const urlOrderDetail = '/admin/orderdetail';
export const urlCreateOrder = '/admin/order/create-order';
export const urlOrderGeneralReport = '/admin/ordergeneral/report';
export const urlOrderOrdersReport = '/admin/orderorders/report';
export const urlOrderProductsReport = '/admin/orderproducts/report';
export const urlProductsOrder = '/admin/product';
export const urlCreateProduct = '/admin/createProduct';
export const urlAdminBuild = '/admin/build';
export const urlAssistant = '/admin/ai-agents';
export const urlAssistantConfig = '/admin/ai-agents/config';
export const urlProfileSettings = '/admin/profile-settings';
export const urlSecuritySettings = '/admin/security-settings';
export const urlCalls = '/admin/calls';
